export function searchITunes(query) {
  const src = new URL('https://itunes.apple.com/search');
  for (const key in query) {
    src.searchParams.append(key, query[key]);
  }

  src.searchParams.append('callback', 'itunesSearchCallback');

  const script = document.createElement('script');
  script.src = src.toString();
  document.body.appendChild(script);

  return new Promise((resolve) => {
    window.itunesSearchCallback = (data) => {
      resolve(data.results?.[0] || null);
      script.remove();
    };
  });
}

export function searchITunesUrl(url) {
  // Match /app/{app_name}/id{id} pattern (e.g., /app/instagram/id389801252)
  const match = url.match(/\/app\/([^\/]+)\/id(\d+)/);
  if (!match) {
    return Promise.resolve(null);
  }

  // Extract app name and ID, construct term as {app_name}-id{id}
  const appName = match[1];
  const id = match[2];
  const term = `${appName}-id${id}`;

  return searchITunes({
    media: 'software',
    term,
  });
}
